var _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerysad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 1024",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.04112 496.314C13.7705 214.195 247.82-7.48482 527.806 1.17857C807.792 9.84197 1027.69 245.568 1018.96 527.686C1010.23 809.805 776.18 1031.48 496.194 1022.82C216.208 1014.16-3.68828 778.432 5.04112 496.314Z",
    fill: "#90bdf9",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.226 513.264C348.85 513.997 348.142 515.126 347.734 515.891C347.733 515.908 347.733 515.912 347.732 515.928C321.799 562.177 304.57 599.685 288.841 650.549C277.632 686.8 251.43 743.691 266.604 780.066C281.995 816.96 372.757 831.676 404.214 792.752C425.796 766.047 419.343 731.236 412.54 698.855C412.464 698.65 412.275 698.208 412.195 697.99C406.334 682.076 402.091 668.527 393.784 640.282C393.565 639.537 393.565 639.564 393.346 638.82C387.487 618.897 384.76 609.91 381.175 599.014C378.942 592.229 376.354 585.243 372.647 575.843C371.724 573.501 371.083 571.901 369.237 567.273C359.714 543.403 355.706 532.266 352.229 518.184C352.148 517.856 352.237 517.545 352.185 517.217C351.004 515.127 349.998 513.697 349.226 513.264Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.845 377.354C259.478 324.554 302.942 283.055 354.924 284.663C406.905 286.272 447.72 330.379 446.087 383.179C444.453 435.979 400.989 477.478 349.008 475.87C297.026 474.261 256.211 430.154 257.845 377.354Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.313 393.855C600.947 341.054 644.411 299.555 696.392 301.164C748.374 302.772 789.189 346.879 787.555 399.679C785.921 452.479 742.458 493.979 690.476 492.37C638.494 490.762 597.679 446.655 599.313 393.855Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.792 717.838L720.021 725.982",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerysad);
export default __webpack_public_path__ + "static/media/Very sad.f8fe0fc88b28edb48b730e8a181cae15.svg";
export { ForwardRef as ReactComponent };